const NODE_TYPE_MAPPING = {
  0: 'Static Step',
  1: 'General Domain',
  2: 'General Skill Set',
  3: 'Code Step',
  4: 'Output Step',
};

const ENTITY_TYPES = {
  REGEX: 'regex',
  BUDGET: 'budget',
  NUMBER: 'numeric_range',
  TIME: 'time',
  DATE: 'date',
  ATTACHMENT: 'attachment',
  TEXT: 'text',
  CURRENCY: 'number_range',
  PHONE_NUMBER: 'phone_number',
  PERSON_NAME: 'person_name',
};

export { NODE_TYPE_MAPPING, ENTITY_TYPES };
